import { useMutation } from "@tanstack/react-query";
import { deleteImageCompressionCache } from "../openapi/api-client.ts";

export const useDeleteImageCompressionCache = (
  projectId: string,
  appInstallationId: string,
) => {
  return useMutation({
    mutationFn: () => {
      return deleteImageCompressionCache({
        path: { projectId, appInstallationId },
      });
    },
    // Keine automatische Invalidierung - wird manuell getriggert
  });
};
